import createBaseService from "@/api/base-service.ts";
import type { Site } from "../../types/site";

const siteService = {
	...createBaseService<Site>("/sites"),
};

export default siteService;
